import React from 'react';

import { OfferYMapFlatPlacemark } from '../flat/FlatPlacemark';
import { OfferYMapFlatMulti } from '../flat/FlatMulti';
import { OfferYMapRoomMulti } from '../room/RoomMulti';
import { OfferYMapRoomPlacemark } from '../room/RoomPlacemark';
import { OfferYMapHousePlacemark } from '../house/HousePlacemark';
import { OfferYMapLandPlacemark } from '../land/LandPlacemark';
import { OfferYMapHouseMulti } from '../house/HouseMulti';
import { OfferYMapLandMulti } from '../land/LandMulti';
import { OfferYMapUnionPlacemarkItem } from './UnionPlacemarkItem';

export function OfferYMapUnionPlacemark({
    item,
    targetBlank = true
}: {
    targetBlank?: boolean;
    item: OfferYMapUnionPlacemarkItem;
}) {
    switch (item.kind) {
        case 'flatMulti':
            return <OfferYMapFlatMulti {...item} key={item.id} targetBlank={targetBlank} />;

        case 'roomMulti':
            return <OfferYMapRoomMulti {...item} key={item.id} targetBlank={targetBlank} />;

        case 'houseMulti':
            return <OfferYMapHouseMulti {...item} key={item.id} targetBlank={targetBlank} />;

        case 'landMulti':
            return <OfferYMapLandMulti {...item} key={item.id} targetBlank={targetBlank} />;

        case 'flat':
            return <OfferYMapFlatPlacemark {...item} key={item.id} targetBlank={targetBlank} />;

        case 'room':
            return <OfferYMapRoomPlacemark {...item} key={item.id} targetBlank={targetBlank} />;

        case 'house':
            return <OfferYMapHousePlacemark {...item} key={item.id} targetBlank={targetBlank} />;

        case 'land':
            return <OfferYMapLandPlacemark {...item} key={item.id} targetBlank={targetBlank} />;

        default:
            return null;
    }
}
